var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticStyle: { "margin-top": "2rem" } }, [
    _c(
      "div",
      { staticClass: "form__group field" },
      [
        _c("b-form-input", {
          staticClass: "form__field",
          attrs: {
            type: "text",
            id: "firstName",
            name: "firstName",
            required: "",
            placeholder: "Vorname",
          },
          model: {
            value: _vm.localContact.firstName,
            callback: function ($$v) {
              _vm.$set(_vm.localContact, "firstName", $$v)
            },
            expression: "localContact.firstName",
          },
        }),
        _vm._v(" "),
        _c(
          "label",
          { staticClass: "form__label", attrs: { for: "firstName" } },
          [_vm._v("Vorname *")]
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "form__group field" },
      [
        _c("b-form-input", {
          staticClass: "form__field",
          attrs: {
            type: "text",
            id: "lastName",
            name: "lastName",
            required: "",
            placeholder: "Nachname",
          },
          model: {
            value: _vm.localContact.lastName,
            callback: function ($$v) {
              _vm.$set(_vm.localContact, "lastName", $$v)
            },
            expression: "localContact.lastName",
          },
        }),
        _vm._v(" "),
        _c(
          "label",
          { staticClass: "form__label", attrs: { for: "lastName" } },
          [_vm._v("Nachname *")]
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "form__group field" },
      [
        _c("b-form-input", {
          staticClass: "form__field",
          attrs: {
            type: "text",
            id: "company",
            name: "company",
            placeholder: "Firma/Einrichtung",
          },
          model: {
            value: _vm.localContact.company,
            callback: function ($$v) {
              _vm.$set(_vm.localContact, "company", $$v)
            },
            expression: "localContact.company",
          },
        }),
        _vm._v(" "),
        _c("label", { staticClass: "form__label", attrs: { for: "company" } }, [
          _vm._v("Firma/Einrichtung"),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "form__group field" },
      [
        _c("b-form-input", {
          staticClass: "form__field",
          attrs: {
            type: "email",
            id: "email",
            name: "email",
            placeholder: "Email",
            required: "",
          },
          model: {
            value: _vm.localContact.email,
            callback: function ($$v) {
              _vm.$set(_vm.localContact, "email", $$v)
            },
            expression: "localContact.email",
          },
        }),
        _vm._v(" "),
        _c("label", { staticClass: "form__label", attrs: { for: "email" } }, [
          _vm._v("Email *"),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "form__group field" },
      [
        _c("b-form-input", {
          staticClass: "form__field",
          attrs: {
            type: "tel",
            id: "phone",
            name: "phone",
            placeholder: "+49...",
          },
          model: {
            value: _vm.localContact.phone,
            callback: function ($$v) {
              _vm.$set(_vm.localContact, "phone", $$v)
            },
            expression: "localContact.phone",
          },
        }),
        _vm._v(" "),
        _c("label", { staticClass: "form__label", attrs: { for: "phone" } }, [
          _vm._v("Telefon"),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }